export default __webpack_public_path__ + "static/media/CNo.67-2.b9b15c89.jpg";